import { base_encode } from "near-api-js/lib/utils/serialize";
import { timestampToDate } from "./datetime";

export const mediaURL = (ipfsHash) => {
  return `https://ipfs.io/ipfs/${ipfsHash}`;
}

export const convertToTera = (amount) => {
  return `${amount}000000000000`;
};

export const transformOneMessage = (message, accountId, isUserFirst, isDateFirst, isLast, isTemporary) => {
  message.isEncryptStart = message.text.includes("(secret-start:");
  message.isEncryptAccept = message.text.includes("(secret-accept:");
  message.isEncryptEnd = message.text.includes("(secret-end)");
  message.isMy = message.from_address === accountId;
  message.isTemporary = isTemporary;
  message.isUserFirst = isUserFirst;
  message.isDateFirst = isDateFirst;
  message.isLast = isLast;
  message.opponentAddress = message.isMy ? message.to_address : message.from_address;

  if (message.reply_message) {
    message.reply_message = transformOneMessage(message.reply_message, accountId, false, false, false, false)
  }

  return message;
}

export const transformProfile = (address, socialProfile) => {
  let resultProfile = {id: address};
  if (socialProfile && Object.keys(socialProfile).length > 0) {
    const profile = socialProfile.profile;
    if (profile.name) {
      resultProfile['name'] = profile.name;
    }
    if (profile.image) {
      resultProfile['image'] = profile.image.ipfs_cid;
    }
  }
  return resultProfile;
}

export const transformMessages = (messages, accountId, lastMessageDate, lastMessageUser) => {
  return messages.map((message, index) => {
    const date = timestampToDate(message.created_at);
    const isLast = !messages[index + 1] || messages[index + 1].from_address !== message.from_address;
    const isDateFirst = date !== lastMessageDate;
    const isUserFirst = message.from_address !== lastMessageUser;
    const result = transformOneMessage(message, accountId, isUserFirst, isDateFirst, isLast, false);

    lastMessageDate = date;
    lastMessageUser = message.from_address;
    return result;
  });
}

export const decodeMessageText = (message) => {
  let result = message.text;

  // Replace message text for secret chat events
  if (message.isEncryptAccept) {
    result = "Private chat request accepted";
  } else if (message.isEncryptEnd) {
    result = "Private chat disabled";
  } else if (message.isEncryptStart) {
    result = "Private chat request";
  }

  return result;
}

export const getInnerId = (text, image, toAddress) => {
  const inner_id = base_encode(`${text}:${image}:${toAddress}`);
  if (inner_id.length > 10) {
    return inner_id.slice(0, 10);
  }
  return inner_id;
}

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index;
}

export const generateTemporaryMessage = (text, image, accountId, opponentAddress, encryptKey) => {
  const inner_id = getInnerId(text, image, opponentAddress);
  const message = {
    id: inner_id,
    from_address: accountId,
    to_address: opponentAddress,
    text,
    inner_id,
    image,
    encrypt_key: encryptKey || ""
  }
  return transformOneMessage(message, accountId, true, true, true, true);
}